export default "__VITE_ASSET__mCER3GxY__"